import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './index.scss';
import '../scss/public.scss';
import Color from '@tool/color';
import {
  ChartIconInActive, ChartIconActive,
  TableIconInActive, TableIconActive,
} from '@styled/icon';
import moCityRate, {
  changeType, initCityRate,
} from './store';
import Chart from './chart';
import CommonTable from './table';
import CityChoose from './city-choose';
import moIndex, { toggleTip } from '../../store/index';
import City from './city';
import Empty from '@comp/empty/index';
import moUser from '@store/user';
import { exportExcelFile, newRate, newValue } from '@tool/index';
import moCityStore, { toggleModal } from './city-store';

interface IProps {}
interface IState {}

const DIconButton = styled(IconButton)(() => ({
  width: '32px',
  height: '20px',
  marginRight: '2px',
  borderRadius: '3px',
}));

const ActiveType = styled(DIconButton)(() => ({
  backgroundColor: Color.primary,
  '&:hover': { backgroundColor: Color.primary },
}));

const InActiveType = styled(DIconButton)(() => ({
  backgroundColor: Color.fff,
  '&:hover': { backgroundColor: Color.fff },
}));

// 涨薪率 - 城市涨薪率
const CityRate = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { isLogin } = moUser;
  const { industry, isMock } = moIndex;
  const {
    type, xData, yData, overview, labels,
    tableLeft, tableRight,
  } = moCityRate;
  const { list } = moCityStore;
  const descArr = ["统计说明：在相同行业、城市组合下，计算各职能月度薪酬的中位数，然后计算月度薪酬的同比变化率，最后计算各统计周期下的变化率均值，即为涨薪率"];


  const exporttable = () => {
    if (moUser.isIndicatorExpired) {
      toggleTip(true);
      return;
    }
    const list :any =[];
    tableLeft.forEach((item:any,i:any)=>{
       const items:any =[item,...tableRight[i]];
       list.push(items);
    })
    const merge:any = [];
    exportExcelFile(list, merge, '城市涨薪率');
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="city-rate_10">
      <section className="one-100">
        <p className="one-11 one-19">
          <strong>城市涨薪率</strong>
          <span className="tag-02">{industry.name}</span>
          {type === 'chart' ? (
            <ActiveType>
              <ChartIconActive />
            </ActiveType>
          ) : (
            <InActiveType onClick={() => changeType('chart')}>
              <ChartIconInActive />
            </InActiveType>
          )}
          {type === 'table' ? (
            <ActiveType>
              <TableIconActive />
            </ActiveType>
          ) : (
            <InActiveType onClick={() => changeType('table')}>
              <TableIconInActive />
            </InActiveType>
          )}
        </p>
        <CityChoose />
      </section>
      <p className="one-13 one-166" style={{ color: '#878787' }}>
        {descArr.map((text: any, ix: number) => (
          <span key={ix}>{text}</span>
        ))}
      </p>

      {type === 'chart' ? (
        <>
          {!isEmpty(xData) ? (
            <section className="box-11">
              <section className={[
                "box-13",
                !isMock ? '' : 'mock-100',
              ].join(' ')}
              style={{ overflowY: 'auto' }}>
                <section className="chart-title_03">
                  {labels.map((item: any, idx: number) => (
                    <p key={idx} className="line-03">
                      <strong>{newRate(item?.change_rate)}</strong>
                      <span>{item?.date}涨薪率</span>
                    </p>
                  ))}
                </section>
                <section style={{
                  width: '100%',
                  overflowY: 'auto',
                }}>
                  <Chart height={300} xData={xData} yData={yData} />
                </section>
              </section>
              <section className="box-150">
                <strong>解读：</strong>
                <section className="box-151">
                  {overview.map((text: any, index: number) => (
                    <p key={index}>
                      <span className="ico-11"><b /></span>
                      <i>{text}</i>
                    </p>
                  ))}
                </section>
              </section>
            </section>
          ) : <Empty padding="50px 0" />}
        </>
      ) : (
        <>
          {type === 'table' && <section onClick={exporttable} className='export-table'>导出excel</section>}
          {!isEmpty(tableRight) ? (
            <section className="box-30top">
              <CommonTable
                leftList={[tableLeft]}
                rightList={tableRight}
              />
            </section>
          ) : <Empty padding="50px 0" />}
        </>
      )}
      <City />
    </section>
  );
};

export default observer(CityRate);
